import { useCallback } from 'react';

import { useTranslation as reactI18nextUseTranslation } from 'react-i18next';

export const createUseTranslation =
  <K extends string>(ns?: string) =>
  () => {
    const { t } = reactI18nextUseTranslation(ns);

    return useCallback(
      (key: K, options?: Parameters<typeof t>[2]) => t(key, options),
      [t]
    );
  };
